import React from "react";
import Skill from './Skill';
import { WorkSkills } from "../../constant";

const Technologies = () => {

    return <div className="cv__technologie pt-5">
        <h4>Langages et technologies</h4>
        <div className="cv__technologie-content pt-3 ps-2 pe-2">
            {WorkSkills.map((v, k) => {
                return <Skill key={k} {...v} />
            })}
        </div>
    </div>
}

export default Technologies;